var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTxt = function SvgTxt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D4EDFF",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.8,
    d: "M9.901 18.162v-1.268h5.973v1.268h-2.226v6.005h-1.52v-6.005H9.9zm8.599-1.268 1.466 2.479h.057l1.474-2.48h1.736l-2.22 3.637 2.27 3.637h-1.768l-1.492-2.483h-.057l-1.491 2.483h-1.762l2.277-3.637-2.234-3.636H18.5zm5.63 1.268v-1.268h5.972v1.268h-2.226v6.005h-1.52v-6.005h-2.227z"
  })));
};
export default SvgTxt;